// extracted by mini-css-extract-plugin
export default {"button":"PzwGd4emMWCDbqulvFrk","emptyNotes":"lGwv7WOGSQPg2ulX9dHO"};